import React, { Component } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import './index.scss';
import { AddEvent, RemoveEvent } from '../../utils/CustomEvent';
import { debounce, getQueryVariable } from '../../utils/utils';
import { DEVICE_DETACTION } from '../../utils/device';
import intl from 'react-intl-universal';

class XscrollList extends Component {
    constructor (props) {
        super(props);
        this.scroller = React.createRef();
        this.iconLeft = React.createRef();
        this.iconRight = React.createRef();
        this.state = {
            // Max horizontal scroll width
            maxScrollWidth: null,
            // Current horizontal scroll offset
            scrollLeft: 0
        }
    }

    componentDidMount () {
        this.setComponentHeight();
        this.setMaxScrollWidth();
        const $scroller = this.scroller.current;
        const $iconLeft = this.iconLeft.current;
        const $iconRight = this.iconRight.current;
        if (!DEVICE_DETACTION.touch) {
            AddEvent($scroller, {
                'dragging': (e, status) => {
                    if (status === 'dragging') {
                        this.scrollTo(e.movementX * -1);
                    }
                }
            });
        }
        AddEvent($iconLeft, {
            'click': this.scrollTo.bind(this, -50)
        }, 'prev');
        AddEvent($iconRight, {
            'click': this.scrollTo.bind(this, 50)
        }, 'prev');
        // Page scrolled to the bottom
        AddEvent($scroller, {
            'scroll': () => {
                const $scroller = this.scroller.current;
                this.setState({ scrollLeft: $scroller.scrollLeft });
            },
            'scrollEnd': this.onScrollEnd.bind(this)
        });
        AddEvent(window, {
            'resize': this.setMaxScrollWidth.bind(this)
        });
    }

    componentDidUpdate () {
        this.setMaxScrollWidth();
    }

    componentWillUnmount () {
        const $scroller = this.scroller.current;
        const $iconLeft = this.iconLeft.current;
        const $iconRight = this.iconRight.current;
        RemoveEvent($scroller, 'dragging');
        RemoveEvent($iconLeft, 'holddown');
        RemoveEvent($iconRight, 'holddown');
        RemoveEvent($scroller, 'scroll');
        RemoveEvent($scroller, 'scrollEnd');
        RemoveEvent(window, 'resize');
    }

    // Set component height; subtract scrollbar height to hide it
    setComponentHeight () {
        const $scroller = this.scroller.current;
        if (!$scroller) return ;
        const $scrollWrapper = $scroller.parentNode;
        // Horizontal scrollbar height
        const scrollXHeight = $scroller.offsetHeight - $scroller.clientHeight;
        $scrollWrapper.style.height = $scrollWrapper.offsetHeight - scrollXHeight - 2 + 'px';
    }

    // Compute max scroll range to determine whether reached end
    setMaxScrollWidth () {
        const $scroller = this.scroller.current;
        if (!$scroller) return ;
        const maxScrollWidth = $scroller.scrollWidth - $scroller.clientWidth;
        if (this.state.maxScrollWidth !== maxScrollWidth) {
            this.setState({ maxScrollWidth });
        }
        this.props.onToggleHandle && this.props.onToggleHandle(maxScrollWidth !== 0);
    }

    onScrollEnd = debounce(() => {
        this.props.onScrollEnd && this.props.onScrollEnd();
    }, 100, true)

    // Enter / Space activates the scroll arrows for keyboard users
    // (the mouse path is a native 'click' listener bound in componentDidMount,
    // which is not triggered by keyboard on a role="button" element)
    onIconKeyDown = (num, e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            this.scrollTo(num);
        }
    }

    // Scroll
    scrollTo (num) {
        const $scroller = this.scroller.current;
        let scrollLeft = $scroller.scrollLeft;
        scrollLeft += num;
        $scroller.scrollLeft = scrollLeft;
        this.setState({ scrollLeft: $scroller.scrollLeft });
    }

    render () {
        const { scrollLeft, maxScrollWidth } = this.state;
        // const isMobile = DEVICE_DETACTION.android || DEVICE_DETACTION.ios || DEVICE_DETACTION.mac;
        const platform = getQueryVariable('platform'); // Phantom FoxitReader PhantomOnline MacPhantom Android IOS
        const isMobile = platform === 'Android' || platform === 'IOS';
        const isHideLeftIcon = isMobile || scrollLeft <= 0;
        const isHideRightIcon = isMobile || scrollLeft === maxScrollWidth;
        const ariaScrollLeft = intl.formatMessage({id: 'AriaScrollLeft'});
        const ariaScrollRight = intl.formatMessage({id: 'AriaScrollRight'});
        return (
            <div className={`xscroll-list ${this.props.className||''}`}>
                <div ref={this.iconLeft} className={`xscroll-list-icon-left ${isHideLeftIcon?'xscroll-hide':''}`} role="button" tabIndex={0} aria-label={ariaScrollLeft} onKeyDown={(e)=>this.onIconKeyDown(-50, e)}><LeftOutlined /></div>
                <div ref={this.iconRight} className={`xscroll-list-icon-right ${isHideRightIcon?'xscroll-hide':''}`} role="button" tabIndex={0} aria-label={ariaScrollRight} onKeyDown={(e)=>this.onIconKeyDown(50, e)}><RightOutlined /></div>
                <div className='xscroll-list-scroll-wrapper'>
                    <div ref={this.scroller} className='xscroll-list-scroll' style={this.props.style}>{this.props.children}</div>
                </div>
            </div>
        )
    }
}

export default XscrollList;
